import { memo, forwardRef } from 'react'

import { StoreOfferProduct } from '@common'
import cx from 'classnames'

import { useGameSlug } from '../../game-provider'
import { ProductRibbon } from '../cardRibbon/ProductRibbon'
import { OFFER_BG } from '../constants'
import { Flare } from '../flare/Flare'
import { OfferValueBadge } from '../offerValueBadge/OfferValueBadge'
import { CardBase } from './CardBase'
import { CardOfferFooter } from './CardOfferFooter'
import { useHandleClick } from './useHandleClick'

import base from './cardBase.module.scss'
import styles from './cardOfferContainer.module.scss'

type BundleProps = {
  offerType: 'offer' | 'bundle'
  children?: React.ReactNode
  offerValue?: number
  product: StoreOfferProduct
  flare?: boolean
  brawlSingleOffer?: boolean
}

export const CardOfferContainer = memo(
  forwardRef(
    (
      { children, offerType, product, flare, brawlSingleOffer = false }: BundleProps,
      ref: React.Ref<HTMLDivElement>,
    ) => {
      const gameSlug = useGameSlug()
      const pathname = `/game/${gameSlug}/product/${product.slug}`

      const { handleClick } = useHandleClick({ product, pathname })

      const bgImage = gameSlug === 'clashroyale' && offerType === 'offer' ? OFFER_BG(gameSlug) : undefined

      return (
        <CardBase
          href={pathname}
          className={cx(base[offerType], base[gameSlug], product.contents.length > 8 && base.moreThanEightItems)}
          backgroundImage={bgImage}
          onClick={handleClick}
        >
          <OfferValueBadge offerProduct={product} game={gameSlug} />
          {flare && <Flare />}
          <ProductRibbon product={product} position="s" />
          <div
            className={cx(styles.content, styles[gameSlug], styles[offerType], {
              [styles.brawlSingleOffer]: brawlSingleOffer,
            })}
            ref={ref}
          >
            {children}
          </div>
          <CardOfferFooter product={product} offerType={offerType} />
        </CardBase>
      )
    },
  ),
)

CardOfferContainer.displayName = 'CardBundleContainer'
